const minHeight = typeof window !== 'undefined' && window.innerHeight;

const styles = {
    splitView: {
        display: "flex", flexDirection:"row", alignItems:"stretch",
        overflow: "hidden",
        minHeight: 0
    },
    treeViewPanel: {
        border: "solid 1px grey",
        overflow: "auto",
        minHeight: 0
    },
    divider:{
        width: "1px",
        padding:"0",
        margin:"0",
        border: "1px solid #808080",
    },
    dividerHitbox: {
        cursor: "col-resize",
        display: "flex",
        padding: "0 1rem 0 0",
        width:"0px",
        backgroundColor: "white",
        zIndex: 1
      },
    content: {
        flex: 1,
        overflow: "auto",
        minHeight: 0
    }
  };

  export default styles
